import { PaymentScheduleType } from '../../state/configuration/config'
import { Data } from './data'
import { Endorsement } from './endorsement'
import { InsuredAsset } from './insuredAsset'
import { InsuredProfile } from './insuredProfile'
import { AdditionalPriceOption, PriceOption } from './priceOption'

export enum QuoteStatus {
  QUOTE = 'QUOTE',
  REFERRAL = 'REFERRAL',
}

export interface Quote {
  proposalCode: string
  data: Data
  insuredAssets: InsuredAsset[]
  insuredProfiles: InsuredProfile[]
  endorsements: Endorsement[]
  promoCode?: string
  wordingVersion: string
  ratingStatus: QuoteStatus
  riskProfileId: string
  referralReasons: ReferralReason[]
  requestedOptionalCovers: Record<string, boolean>
  mainInsurer: string
  availableCoverLevelOptions: CoverLevelOption[]
}

export interface CoverLevelOption {
  active: boolean

  paymentScheduleType: PaymentScheduleType
  coverLevel: string

  additionalPremiumBreakdown: AdditionalPriceOption[]
  promotion?: Promotion

  premiumBreakdown: PriceOption[]

  basePremiumItems: BasePremiumItem[]
  coverOptionItems: CoverOptionItem[]
}

export interface CoverOptionItem {
  coverOption?: string
  insurer: string
  premium: number
  totalPremium: number
  taxAmount: number
  active: boolean
}

export interface BasePremiumItem {
  insurer: string
  covers: string[]
  premium: number
  totalPremium: number
  taxAmount: number
}

export interface Promotion {
  discountAmt: number
  endAt?: string
}

export interface ReferralReason {
  message: string
}
